import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    ElementRef,
    inject,
    signal,
    viewChild
} from '@angular/core';
import {
    CellCommentEditorComponent,
    EditableComment
} from '../components/cell-comment-editor/cell-comment-editor.component';
import {ComponentTooltip, ComponentTooltipService} from '../components/component-tooltip/component-tooltip.service';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CellCommentEditorComponent
    ],
    template: `
        <div class="layout-vbox" style="gap: 10px">
            <div>Cell comments go here</div>
            <app-cell-comment-editor [(comments)]="myComments"
                style="border: 1px solid black; min-height: 100px; min-width: 200px; max-width: 500px; resize: both">
            </app-cell-comment-editor>
            <textarea #text style="width: 500px; height: 300px" placeholder="Enter your comments here"></textarea>
            <div class="toolbar-horizontal">
                <fluent-button (click)="addComment()">Add</fluent-button>
                <fluent-button (click)="dumpComments()">Dump</fluent-button>
                <fluent-button #toolTipEl>Tooltip</fluent-button>
                <fluent-button (click)="triggerTooltip(toolTipEl)">Trigger Tooltip</fluent-button>
            </div>
        </div>
    `,
    styles: `
    `
})
export class TestCommentEditorComponent implements AfterViewInit {

    private textArea = viewChild.required<ElementRef<HTMLTextAreaElement>>('text');

    private tt: ComponentTooltip<CellCommentEditorComponent>;
    private ttEl = viewChild.required<ElementRef<HTMLDivElement>>('toolTipEl');

    protected myComments = signal<EditableComment[]>([]);

    private readonly compTooltipSvc = inject(ComponentTooltipService);

    constructor() {
        this.tt = this.compTooltipSvc.create(CellCommentEditorComponent, {
            width: '200px',
            maxHeight: '300px',
            height: 'fit-content',
            padding: '0px',
            isResizable: true,
            beforeShow: this.beforeTt2Show.bind(this),
            afterHide: this.afterTt2Hide.bind(this)
        });
    }

    async ngAfterViewInit(): Promise<void> {
        this.tt.setTooltip(this.ttEl(), { a: 1 });
    }

    protected addComment() {
        const content = this.textArea().nativeElement.value;
        const comment: EditableComment = {
            createdAt: new Date(),
            createdBy: 'heim@abc.com',
            content
        };
        this.myComments().push(comment);
        this.textArea().nativeElement.value = '';
    }

    private beforeTt2Show (tt: ComponentTooltip<CellCommentEditorComponent>, el: HTMLElement, init: any, data: string) {
        init.comments = this.myComments();
    }

    private afterTt2Hide (tt: ComponentTooltip<CellCommentEditorComponent>, comp: CellCommentEditorComponent, el: HTMLElement, data: string) {
        const editedComments = comp.comments();
        console.log(editedComments);
    }

    protected dumpComments() {
        console.log(this.myComments());
    }

    protected async triggerTooltip(el: HTMLElement) {
        await this.tt.show(el);
    }
}
